import { render, staticRenderFns } from "./sayout-loud.vue?vue&type=template&id=3a5efc31&scoped=true"
import script from "./sayout-loud.ts?vue&type=script&lang=ts&external"
export * from "./sayout-loud.ts?vue&type=script&lang=ts&external"
import style0 from "./sayout-loud.scss?vue&type=style&index=0&id=3a5efc31&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5efc31",
  null
  
)

export default component.exports